// this host renders Tailwind markup in its shadow root, so it needs the Tailwind flavoured base class
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { type Person } from '../../users/entities/person.js';
import { MitarbeiterTicket } from '../components/job-ticket/MitarbeiterTicket.js';
import { PageHeader } from '@martinus/styles/client/PageHeader.js';

/**
 * @element sg-standalone-ticket
 */
@customElement('sg-standalone-ticket')
export class SgStandaloneTicket extends ChemistryLitElement {
  private readonly _currentUser = new RXController(this, currentUser<Person>());

  override render() {
    return html`
      <div class="flex flex-col h-full">
        ${this._header()}
        <div class="grow overflow-y-auto">
          ${this._currentUser.value ? MitarbeiterTicket({ personID: this._currentUser.value._id }) : nothing}
        </div>
      </div>
    `;
  }

  private _header() {
    return html` ${PageHeader({ title: 'Job-Ticket Bestellung' })} `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          height: '100%',
          paddingBottom: this.spacing.md,
        },
      },
    ];
  }
}
